import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface TranslationOutputProps {
  russianText: string;
  heatmapUrl: string;
  isLoading: boolean;
  error: string | null;
  hasInput: boolean;
}

const TranslationOutput: React.FC<TranslationOutputProps> = ({ russianText, heatmapUrl, isLoading, error, hasInput }) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex flex-col items-center justify-center h-full text-center p-4">
          <LoadingSpinner />
          <p className="mt-4 text-pink-500">Translating...</p>
        </div>
      );
    }

    if (error) {
      return <div className="p-4 text-red-500">{error}</div>;
    }
    
    if (!hasInput) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-center p-4 text-gray-400">
                <p>Translation and attention map will appear here.</p>
            </div>
        );
    }

    if (russianText) {
      return (
        <div className="p-4 flex flex-col h-full">
          <p className="text-lg text-gray-800 flex-grow">{russianText}</p>
          {heatmapUrl && (
            <div className="mt-4">
              <h3 className="text-sm font-semibold text-gray-500 mb-2">Attention Visualization</h3>
              <img src={heatmapUrl} alt="Attention Heatmap" className="rounded-lg w-full object-cover border border-gray-200" />
            </div>
          )}
        </div>
      );
    }
    
    return null;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-lg flex flex-col h-full">
      <div className="flex-grow min-h-[300px] flex flex-col justify-center">
        {renderContent()}
      </div>
    </div>
  );
};

export default TranslationOutput;